import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatProgressBarModule, MatProgressSpinnerModule, MatTabsModule, MatToolbarModule, MatTooltipModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';
import { PipesModule } from '../../../../../@fuse/pipes/pipes.module';
import { DisclaimerModule } from '../../../../core/components/disclaimer/disclaimer.module';
import { FcOutlinedInputModule } from '../../../../core/components/fc-input/base/fc-outlined-input/fc-outlined-input.module';
import { FcOutlinedTextareaModule } from '../../../../core/components/fc-input/base/fc-outlined-textarea/fc-outlined-textarea.module';
import { FcTextAreaInputModule } from '../../../../core/components/fc-input/base/fc-text-area-input/fc-text-area-input.module';
import { FcTextInputModule } from '../../../../core/components/fc-input/base/fc-text-input/fc-text-input.module';
import { FcLocationInputModule } from '../../../../core/components/fc-input/search-one/fc-location-input/fc-location-input.module';
import { FcLocationSectorInputModule } from '../../../../core/components/fc-input/search-one/fc-location-sector-input/fc-location-sector-input.module';
import { ViewQrCodeModalModule } from '../../../../core/components/view-qr-code-modal/view-qr-code-modal.module';
import { DirectivesModule } from '../../../../core/directives/directives.module';
import { DialogLocationEnvironmentComponent } from './dialog-location-environment.component';
import { TabGeneralComponent } from './tabs/general/tab-general.component';
import { TabMaintenancesService } from './tabs/maintenances/services/tab-maintenances.service';
import { TabMaintenancesComponent } from './tabs/maintenances/tab-maintenances.component';

@NgModule({
  entryComponents: [
    DialogLocationEnvironmentComponent,
  ],
  declarations: [
    DialogLocationEnvironmentComponent,
    TabGeneralComponent,
    TabMaintenancesComponent,
  ],
  imports: [
    NgxMaskModule.forRoot(),
    TranslateModule,
    FuseSharedModule,
    MatTabsModule,
    MatToolbarModule,
    MatIconModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    DisclaimerModule,
    DirectivesModule,
    FcTextInputModule,
    FcOutlinedInputModule,
    FcLocationInputModule,
    FcOutlinedTextareaModule,
    FcLocationSectorInputModule,
    MatDialogModule,
    ViewQrCodeModalModule,
    FcTextAreaInputModule,
    PipesModule,
  ],
  exports: [
    DialogLocationEnvironmentComponent
  ],
  providers: [
    TabMaintenancesService
  ],
  schemas: [
  ]
})
export class DialogLocationEnvironmentModule {}
